module.exports = __webpack_public_path__ + "static/media/trend-overtime.b268c1ca.svg";